module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/_browserify-sign@4.0.4@browserify-sign/algos.js
// module id = teas
// module chunks = 0